import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { LocalizationService } from "../services";
import { Observable } from "rxjs";

@Injectable()
export class LocaleInterceptor implements HttpInterceptor {
  constructor(private translate: LocalizationService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const localeAsString =this.translate.getCurrentLocale().toString();
    request = request.clone({
      setHeaders: {
        Locale: localeAsString,
      },
    });
    return next.handle(request);
  }
}
